import DocumentsPage from "shared/components/dashboardCommon/documentsPage";
import styles from "./styles.module.scss";

const CollaboratorDocuments = () => {
  return (
    <DocumentsPage
      title="All Documents"
      description="Access all your project documents in one place."
      styles={styles}
    />
  );
};

export default CollaboratorDocuments;
